import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faBullseye, faClipboardList, faUsers, faHospital, faBolt } from "@fortawesome/free-solid-svg-icons";
import "./Features.css";

const Features = () => {
    const features = [
        {
            icon: faDollarSign,
            title: "Additional Revenue",
            description: "Receive new PI referrals and provide trusted care that benefits both your patients and your practice.",
        },
        {
            icon: faBullseye,
            title: "Focus on Treatment",
            description: "All you do is the treatment. We'll take care of the rest - scheduling, billing, and records management.",
        },
        {
            icon: faClipboardList,
            title: "Simple Training",
            description: "Follow our simple training program to get started quickly and efficiently with minimal learning curve.",
        },
        {
            icon: faUsers,
            title: "Dedicated Support",
            description: "Meet your support staff for all scheduling, billing, and records. We handle the administrative burden.",
        },
        {
            icon: faHospital,
            title: "Multiple Specialties",
            description: "Perfect for chiropractors, physical therapists, and medical specialists looking to expand their practice.",
        },
        {
            icon: faBolt,
            title: "Quick Setup",
            description: "Sign up in just a few minutes and start seeing new patients in your area with our streamlined process.",
        },
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };

    return (
        <section
            className="features"
            id="features">
            <div className="container">
                <motion.div
                    className="features-header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}>
                    <h2>Why Join Stamp Medical?</h2>
                    <p>We provide everything you need to grow your practice with Personal Injury patients. Focus on what you do best - providing excellent care to your patients.</p>
                </motion.div>

                <motion.div
                    className="features-grid"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}>
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            className="feature-card"
                            variants={itemVariants}
                            whileHover={{
                                scale: 1.05,
                                transition: { duration: 0.2 },
                            }}>
                            <div className="feature-icon">
                                <FontAwesomeIcon icon={feature.icon} />
                            </div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Features;
